import FilterTextInput from "../FilterTextInput";
import { FilterRemove } from "iconsax-react";
import { motion as m } from "framer-motion";
import Paginator from "../Paginator";

const ChangeLogTable = ({
  data,
  meta,
  handlePageClick,
  searchTerm,
  handleSearch,
  handleKeyDown,
  perPage,
  handlePerPageChange,
  clearFilter,
}) => {
  // Format date to "time ago" format
  const formatTimeAgo = (dateString) => {
    if (!dateString) return "-";

    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now - past) / 1000);

    // Less than a minute
    if (diffInSeconds < 60) {
      return `${diffInSeconds} second${diffInSeconds !== 1 ? "s" : ""} ago`;
    }

    // Less than an hour
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes !== 1 ? "s" : ""} ago`;
    }

    // Less than a day
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours !== 1 ? "s" : ""} ago`;
    }

    // Less than a month (30 days)
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
      return `${diffInDays} day${diffInDays !== 1 ? "s" : ""} ago`;
    }

    // Less than a year (365 days)
    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `${diffInMonths} month${diffInMonths !== 1 ? "s" : ""} ago`;
    }

    // More than a year
    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears} year${diffInYears !== 1 ? "s" : ""} ago`;
  };

  return (
    <m.div
      className="flex flex-col border border-[#EFF0F2] w-full h-fit bg-white rounded-xl"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Filters */}
      <div className="flex w-full border-b border-[#EFF0F2] px-[24px] py-[12px] gap-[8px] items-center justify-end">
        {clearFilter && searchTerm !== "" && (
          <FilterRemove
            size="16"
            onClick={clearFilter}
            variant="Bold"
            className="text-[#FF3030] hover:cursor-pointer hover:text-[#5C4BF5]"
          />
        )}
        <FilterTextInput
          value={searchTerm}
          onChange={handleSearch}
          onKeyDown={handleKeyDown}
        />
      </div>

      {/* Table data */}
      <div className="flex w-full h-full gap-[24px] overflow-x-auto">
        {!data || data.length === 0 ? (
          <div className="flex w-full h-[290px] items-center border-[#EFF0F2] justify-center text-gray-500 text-[25px]">
            No Change Log found
          </div>
        ) : (
          <table className="w-full h-full text-nowrap">
            {/* Table Header */}
            <thead>
              <tr className="w-full bg-[#F7F8F9] border-b border-[#EFF0F2]">
                <th className="text-start px-[24px] py-[16px]">Log Type</th>
                <th className="text-start px-[24px] py-[16px]">Description</th>
                <th className="text-start px-[24px] py-[16px]">
                  Changes Made By
                </th>
                <th className="text-start px-[24px] py-[16px]">Date & Time</th>
              </tr>
            </thead>

            {/* Table Body */}
            <tbody>
              {data.map((item) => (
                <tr
                  key={item.id}
                  className="w-full font-normal border-b border-[#EFF0F2] last:border-none"
                >
                  <td className="px-[24px] py-[16px]">
                    <span className="px-[8px] py-[4px] rounded-md text-sm">
                      {item.log_name || "-"}
                    </span>
                  </td>
                  <td className="px-[24px] py-[16px] max-w-[400px]">
                    <div className="truncate" title={item.description}>
                      {item.description || "-"}
                    </div>
                  </td>
                  <td className="px-[24px] py-[16px]">
                    {item.causer_name || "System"}
                  </td>
                  <td className="px-[24px] py-[16px]">
                    {formatTimeAgo(item.created_at)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      {meta && (
        <Paginator
          meta={meta}
          perPage={perPage}
          handlePageClick={handlePageClick}
          handlePerPageChange={handlePerPageChange}
        />
      )}
    </m.div>
  );
};

export default ChangeLogTable;
